// useSortable — multi-sort hook (ústava sek. 66.1 bod 4)
// Klik na header = sortuj, Shift+klik = pridaj druhý kľúč
// Vráti: { sorted, sortKeys, toggleSort, sortIndicator }
//
// sortKeys = [{ key: 'name', dir: 'asc', priority: 1 }, ...]
import { useState, useMemo, useCallback } from 'react'

export function useSortable(data = [], opts = {}) {
  const { initial = [] } = opts
  const [sortKeys, setSortKeys] = useState(initial)  // [{key, dir}]

  const toggleSort = useCallback((key, addToExisting = false) => {
    setSortKeys(prev => {
      const existingIdx = prev.findIndex(k => k.key === key)
      if (!addToExisting) {
        // Single-sort — nahradiť celý zoznam
        if (existingIdx === 0 && prev.length === 1) {
          // Toggle ASC → DESC → reset
          if (prev[0].dir === 'asc') return [{ key, dir: 'desc' }]
          return []
        }
        return [{ key, dir: 'asc' }]
      }
      // Shift — multi-sort
      if (existingIdx >= 0) {
        const cur = prev[existingIdx]
        const next = [...prev]
        if (cur.dir === 'asc') next[existingIdx] = { key, dir: 'desc' }
        else next.splice(existingIdx, 1)  // tretí klik = remove tento kľúč
        return next
      }
      return [...prev, { key, dir: 'asc' }]
    })
  }, [])

  const sorted = useMemo(() => {
    if (!sortKeys.length || !Array.isArray(data)) return data
    return [...data].sort((a, b) => {
      for (const sk of sortKeys) {
        const av = a[sk.key]
        const bv = b[sk.key]
        let cmp
        if (av == null && bv == null) cmp = 0
        else if (av == null) cmp = 1
        else if (bv == null) cmp = -1
        else if (typeof av === 'number' && typeof bv === 'number') cmp = av - bv
        else cmp = String(av).localeCompare(String(bv), 'sk', { sensitivity: 'base' })
        if (cmp !== 0) return sk.dir === 'desc' ? -cmp : cmp
      }
      return 0
    })
  }, [data, sortKeys])

  // Vráti zobrazenie indikátora pre konkrétny kľúč
  const sortIndicator = useCallback((key) => {
    const idx = sortKeys.findIndex(k => k.key === key)
    if (idx < 0) return null
    const dir = sortKeys[idx].dir === 'asc' ? '↑' : '↓'
    return sortKeys.length > 1 ? `${dir}${idx + 1}` : dir
  }, [sortKeys])

  // Onclick handler pre header — auto-detekcia shift
  const sortClick = useCallback((key) => (e) => {
    toggleSort(key, e.shiftKey)
  }, [toggleSort])

  return { sorted, sortKeys, toggleSort, sortClick, sortIndicator }
}

export default useSortable
